// Mock data for pay-at-table prototype
export const MOCK_TABLE_ID = "12";
export const MOCK_ORDER_REF = "T12-2847";

export const MOCK_ORDER = {
  tableId: MOCK_TABLE_ID,
  items: [
    { name: "Burger", qty: 2, price: 6 },
    { name: "Fries", qty: 1, price: 4.5 },
    { name: "Coke", qty: 1, price: 2.5 },
  ],
  currency: "£",
};

export const getOrderTotals = (order = MOCK_ORDER) => {
  if (!order?.items?.length) {
    const st = (order?.subtotal ?? 0) + (order?.tax ?? 0);
    return {
      subtotal: order?.subtotal ?? 0,
      tax: order?.tax ?? 0,
      total: order?.total ?? st,
    };
  }
  const subtotal = order.items.reduce((sum, i) => sum + (i.qty ?? 0) * (i.price ?? 0), 0);
  const tax = order.tax ?? 0;
  const total = order.total ?? (subtotal + tax);
  return { subtotal, tax, total };
};

/**
 * Normalise API order (from GET /api/orders/:id) to pay-at-table display shape.
 * API order may have: order_items, order_gross_total, service_charge, tip, store, table_number, id.
 * @param {object} apiOrder - Raw order from API
 * @returns {object} { orderId, tableId, items, currency, subtotal, tax, total, orderReference }
 */
export function normaliseOrder(apiOrder) {
  if (!apiOrder) return null;
  const orderItems = apiOrder.order_items || [];
  const items = orderItems.map((item) => ({
    name: item.product_name ?? item.name ?? item.product?.name ?? "Item",
    qty: item.quantity ?? item.qty ?? 1,
    price: Number(item.price ?? item.unit_price ?? 0),
  }));
  const store = Array.isArray(apiOrder.store) ? apiOrder.store[0] : apiOrder.store;
  const currencyCode = store?.currency_code ?? apiOrder.currency_code ?? "GBP";
  const currencySymbol = currencyCode === "GBP" ? "£" : currencyCode === "USD" ? "$" : currencyCode;
  const grossTotal = Number(apiOrder.order_gross_total ?? apiOrder.total ?? 0);
  const serviceCharge = Number(apiOrder.service_charge ?? 0);
  const tip = Number(apiOrder.tip ?? 0);
  const itemsSubtotal = items.reduce((s, i) => s + (i.qty ?? 0) * (i.price ?? 0), 0);
  const subtotal = itemsSubtotal || grossTotal - serviceCharge - tip || 0;
  const tax = Number(apiOrder.tax ?? serviceCharge ?? 0);
  const total = grossTotal || itemsSubtotal + tax;
  const tableNumber = apiOrder.table_number ?? apiOrder.table_id ?? apiOrder.tableNumber ?? MOCK_TABLE_ID;
  const orderRef = apiOrder.order_reference ?? apiOrder.reference ?? (apiOrder.id ? `T${tableNumber}-${String(apiOrder.id).slice(-4)}` : MOCK_ORDER_REF);

  return {
    orderId: apiOrder.id,
    tableId: String(tableNumber),
    items,
    currency: currencySymbol,
    currencyCode,
    subtotal,
    tax,
    total,
    orderReference: orderRef,
  };
}
